module.exports = __webpack_public_path__ + "img/qrcode-kl.1f267c51.jpg";